import React from "react";

import {ReactComponent as DownloadIcon} from '../../../../assets/icons/download_icon.svg'
import {CompletePayroll} from "../../../../app/interfaces";
import {DocumentDownloadArea, PayrollDetailsViewContainer} from "./styles";
import {useTranslation} from "react-i18next";
import {
    InputFieldsWrapper,
    InputText,
    PopupLoading,
    PrimaryButton,
} from "../../../../components";
import {downloadDocument, downloadMultipleCompanioDocuments} from "../../../../services/documents";
import {hasBonus} from "../../../../utils";
import {PayrollTitle} from "../../styles";
import {FileDownloadButton} from "../../../../components/FileDownloadButton";
import {
    FETCH_STATUS_LOADING,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT
} from "../../../../utils/constants";
import {useDispatch, useSelector} from "react-redux";
import {updatePayrollState} from "../../../../app/payroll/selectors";
import {updatePayroll} from "../../../../app/payroll/actions";


const PayrollDetailsView = ({payroll} : {payroll: CompletePayroll}) => {
    const dispatch = useDispatch();

    const companyId = payroll.company._id;

    const statusUpdate = useSelector(updatePayrollState)
    const handleSetPayrollAsPaid = () => {
        dispatch(updatePayroll(
          {
              payrollId: payroll._id,
              employeeId: payroll.eor_employee._id,
              status: PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT
          }
        ) as any)
    }

    const {t} = useTranslation()

    if(statusUpdate === FETCH_STATUS_LOADING){
        return <PopupLoading isOpen={true}/>
    }

    return <PayrollDetailsViewContainer>
        <PayrollTitle>
            <div>
                <h1>{t('payroll_details_title')}</h1>
                <p>{t('payroll_details_message')}</p>
            </div>
            {payroll.status === PAYROLL_STATUS_PENDING_COMPANY_PAYMENT &&
              <PrimaryButton onClick={handleSetPayrollAsPaid}>{t('mark_as_paid')}</PrimaryButton>
            }

        </PayrollTitle>

        {payroll.company_invoice && <section>
            <DocumentDownloadArea>
                <div className="label">
                    <h3>{t('company_invoice')}</h3>
                    <p>{t('company_invoice_explanation')}</p>
                    <FileDownloadButton onClick={() => downloadDocument(payroll.company_invoice, companyId)}>
                        {t('download_company_invoice')} <DownloadIcon />
                    </FileDownloadButton>
                </div>
            </DocumentDownloadArea>
        </section>}

        {payroll.payslip && <section>
            <DocumentDownloadArea>
                <div className="label">
                    <h3>{t('payslip')}</h3>
                    <p>{t('payslip_explanation')}</p>
                    <FileDownloadButton onClick={() => downloadDocument(payroll.payslip, companyId)}>
                        {t('download_payslip')} <DownloadIcon />
                    </FileDownloadButton>
                </div>
            </DocumentDownloadArea>
        </section>}

        {payroll.eor_partner_invoices && Array.isArray(payroll.eor_partner_invoices) && payroll.eor_partner_invoices.length > 0 && <section>

            <DocumentDownloadArea>
                <div className="label">
                    <h3>{t('eor_partner_invoice')}</h3>
                    <p>{t('eor_partner_invoice_explanation')}</p>
                    <div style={{paddingTop: 12}}>
                        <FileDownloadButton onClick={() => downloadMultipleCompanioDocuments(payroll.eor_partner_invoices)}>
                            {t('download_eor_partner')} <DownloadIcon />
                        </FileDownloadButton>
                    </div>
                </div>
            </DocumentDownloadArea>
        </section>}

        {hasBonus(payroll) && <section>
            <h3>{t('bonus_information')}</h3>
            <InputFieldsWrapper>
                <InputText
                    readOnly
                    label={t('currency') as string}
                    value={payroll.bonus.amount}
                />
                <InputText
                    readOnly
                    label={t('currency') as string}
                    value={payroll.bonus.currency}>
                </InputText>
            </InputFieldsWrapper>
            <InputText
                readOnly
                label={t('description') as string}
                value={payroll.bonus.description || ''}>
            </InputText>
        </section>}

        <section>
            <h3>{t('payroll_costs')}</h3>
            <InputFieldsWrapper>
                <InputText
                    readOnly
                    label={t('gross_salary') as string}
                    value={payroll.gross_salary}
                />
                <InputText
                    readOnly
                    label={t('currency') as string}
                    value={payroll.eor_employee.salary.currency}>
                </InputText>
            </InputFieldsWrapper>
            <InputFieldsWrapper>
                <InputText
                    readOnly
                    label={t('eor_fee') as string}
                    value={payroll.eor_fee}/>
                <InputText
                    readOnly
                    label={t('social_taxes') as string}
                    value={payroll.social_taxes}
                />
            </InputFieldsWrapper>
            {payroll.is_first_payroll && <InputFieldsWrapper>
                <InputText
                    readOnly
                    label={t('setup_fee') as string}
                    value={payroll.setup_fee}
                />
                <InputText
                    readOnly
                    label={t('security_deposit') as string}
                    value={payroll.security_deposit}
                />
            </InputFieldsWrapper>}
        </section>

    </PayrollDetailsViewContainer>
}

export default PayrollDetailsView;
